module.exports = __webpack_public_path__ + "static/media/Pattern13.9e2da49d.png";